<template>
  <b-container class="py-4" style="max-width: 820px">
    <div class="d-flex align-items-center mb-3">
      <b-button variant="light" @click="$router.go(-1)">← Volver</b-button>
      <h2 class="mb-0 ml-3">Versión de caja</h2>
    </div>

    <b-alert v-if="!cargado" show variant="info">Cargando…</b-alert>
    <b-alert v-else-if="noExiste" show variant="danger">No se encontró la versión.</b-alert>

    <template v-if="cargado && !noExiste">
      <b-card class="mb-3">
        <div class="d-flex align-items-center">
          <img v-if="padreFoto" :src="padreFoto" alt="padre" style="width: 72px; height: 72px; object-fit: cover; border-radius: 8px" class="mr-3" />
          <div>
            <small class="text-muted d-block">Escapada padre (hereda fotos, descripción y reseñas)</small>
            <strong>{{ padreTitulo || version.padreId }}</strong>
          </div>
        </div>
      </b-card>

      <b-form @submit.prevent="guardar">
        <b-card class="mb-3">
          <I18nField
            label="Nombre de la versión"
            type="text"
            :value-es="version.nombre"
            :value-en="ingles.nombre"
            :value-pt="portugues.nombre"
            :manual-override="ov('nombre')"
            @change="(l, v) => setI18n('nombre', l, v)"
          />
          <b-row>
            <b-col md="6">
              <b-form-group label="Noches">
                <b-form-input v-model.number="version.noches" type="number" min="0" />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Valor de referencia interno (CLP)" description="No se muestra al público. Solo control de margen.">
                <b-form-input v-model.number="version.valorReferencia" type="number" min="0" />
              </b-form-group>
            </b-col>
          </b-row>
          <I18nField
            label="Itinerario resumido"
            type="textarea"
            :value-es="version.itinerarioResumen"
            :value-en="ingles.itinerarioResumen"
            :value-pt="portugues.itinerarioResumen"
            :manual-override="ov('itinerarioResumen')"
            @change="(l, v) => setI18n('itinerarioResumen', l, v)"
          />
        </b-card>

        <b-card class="mb-3">
          <I18nField
            label="Incluye"
            type="array-strings"
            :value-es="version.incluye"
            :value-en="ingles.incluye"
            :value-pt="portugues.incluye"
            :manual-override="ov('incluye')"
            @add-item="(l, it) => addItem('incluye', l, it)"
            @remove-item="(l, i) => removeItem('incluye', l, i)"
          />
          <I18nField
            label="No incluye"
            type="array-strings"
            :value-es="version.noIncluye"
            :value-en="ingles.noIncluye"
            :value-pt="portugues.noIncluye"
            :manual-override="ov('noIncluye')"
            @add-item="(l, it) => addItem('noIncluye', l, it)"
            @remove-item="(l, i) => removeItem('noIncluye', l, i)"
          />
        </b-card>

        <b-card class="mb-3" title="Pertenece a las cajas">
          <p class="text-muted">Marca las cajas donde debe aparecer esta alternativa (asignación manual).</p>
          <b-form-checkbox-group v-model="version.cajaSlugs" stacked>
            <b-form-checkbox v-for="c in cajas" :key="c.slug" :value="c.slug">
              {{ c.nombre }} <small class="text-muted">({{ c.slug }})</small>
            </b-form-checkbox>
          </b-form-checkbox-group>
          <b-alert v-if="!cajas.length" show variant="light" class="mt-2 mb-0">Aún no hay cajas creadas.</b-alert>
        </b-card>

        <b-card class="mb-3" title="Fechas no disponibles (feriados / temporada alta)">
          <p class="text-muted">
            La escapada es de fecha abierta sujeto a disponibilidad, pero con excepción de estas fechas.
            Para un solo día, deja “hasta” igual a “desde” (o vacío).
          </p>
          <b-table
            v-if="version.restriccionesFechas.length"
            :items="version.restriccionesFechas"
            :fields="[
              { key: 'desde', label: 'Desde' },
              { key: 'hasta', label: 'Hasta' },
              { key: 'motivo', label: 'Motivo' },
              { key: 'acciones', label: '' },
            ]"
            small
            responsive
          >
            <template #cell(acciones)="r">
              <b-button size="sm" variant="outline-danger" @click="quitarRestriccion(r.index)">Quitar</b-button>
            </template>
          </b-table>
          <b-row class="align-items-end">
            <b-col md="3"><b-form-group label="Desde"><b-form-input v-model="nuevaRestriccion.desde" type="date" /></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Hasta"><b-form-input v-model="nuevaRestriccion.hasta" type="date" /></b-form-group></b-col>
            <b-col md="4"><b-form-group label="Motivo"><b-form-input v-model="nuevaRestriccion.motivo" placeholder="ej. Fiestas Patrias" /></b-form-group></b-col>
            <b-col md="2"><b-button variant="outline-primary" block @click="agregarRestriccion">Agregar</b-button></b-col>
          </b-row>
        </b-card>

        <b-card class="mb-3">
          <b-form-checkbox v-model="version.publicada" switch>Publicada (visible dentro de sus cajas)</b-form-checkbox>
        </b-card>

        <div class="d-flex justify-content-between">
          <b-button type="submit" variant="primary" :disabled="guardando">{{ guardando ? "Guardando…" : "Guardar versión" }}</b-button>
          <b-button variant="outline-danger" @click="eliminar">Eliminar versión</b-button>
        </div>
      </b-form>
    </template>
  </b-container>
</template>

<script>
import { db } from "../../firebase.service";
import firebase from "../../firebase.service";
import I18nField from "../../components/I18nField.vue";

export default {
  name: "EditVersionCaja",
  components: { I18nField },
  data() {
    return {
      version: { nombre: "", noches: 0, itinerarioResumen: "", incluye: [], noIncluye: [], cajaSlugs: [], valorReferencia: 0, restriccionesFechas: [], publicada: false, ingles: {}, portugues: {}, manualOverride: {}, padreId: "", padreSlug: "" },
      nuevaRestriccion: { desde: "", hasta: "", motivo: "" },
      padre: null,
      cajas: [],
      cargado: false,
      noExiste: false,
      guardando: false,
    };
  },
  computed: {
    padreId() { return this.$route.params.padreId; },
    vid() { return this.$route.params.vid; },
    ingles() { return this.version.ingles || {}; },
    portugues() { return this.version.portugues || {}; },
    padreTitulo() { return this.padre ? this.padre.titulo : ""; },
    padreFoto() { return this.padre ? (this.padre.carouselImgUrl || (Array.isArray(this.padre.heroImgUrls) ? this.padre.heroImgUrls[0] : "")) : ""; },
  },
  async created() {
    try {
      const [vdoc, pdoc, csnap] = await Promise.all([
        db.collection("experiencias").doc(this.padreId).collection("versiones").doc(this.vid).get(),
        db.collection("experiencias").doc(this.padreId).get(),
        db.collection("cajas").get(),
      ]);
      if (!vdoc.exists) { this.noExiste = true; this.cargado = true; return; }
      this.version = { ...this.version, ...vdoc.data() };
      if (!Array.isArray(this.version.cajaSlugs)) this.version.cajaSlugs = [];
      if (!Array.isArray(this.version.restriccionesFechas)) this.version.restriccionesFechas = [];
      if (!this.version.manualOverride) this.version.manualOverride = {};
      this.padre = pdoc.exists ? pdoc.data() : null;
      this.cajas = csnap.docs.map((d) => ({ slug: d.id, nombre: (d.data() || {}).nombre || d.id }));
    } catch (e) {
      console.warn("[EditVersionCaja] carga fallida:", e && e.message);
    } finally {
      this.cargado = true;
    }
  },
  methods: {
    ov(field) { return (this.version.manualOverride && this.version.manualOverride[field]) || { en: false, pt: false }; },
    markOv(field, lang) {
      const cur = this.version.manualOverride[field] || { en: false, pt: false };
      this.$set(this.version.manualOverride, field, { ...cur, [lang]: true });
    },
    branch(lang) { return lang === "en" ? "ingles" : "portugues"; },
    setI18n(field, lang, value) {
      if (lang === "es") this.$set(this.version, field, value);
      else { this.$set(this.version[this.branch(lang)], field, value); this.markOv(field, lang); }
    },
    addItem(field, lang, item) {
      if (lang === "es") {
        if (!Array.isArray(this.version[field])) this.$set(this.version, field, []);
        this.version[field].push(item);
      } else {
        const b = this.branch(lang);
        if (!Array.isArray(this.version[b][field])) this.$set(this.version[b], field, []);
        this.version[b][field].push(item);
        this.markOv(field, lang);
      }
    },
    removeItem(field, lang, index) {
      const target = lang === "es" ? this.version[field] : (this.version[this.branch(lang)] || {})[field];
      if (Array.isArray(target)) target.splice(index, 1);
    },
    agregarRestriccion() {
      const r = this.nuevaRestriccion;
      if (!r.desde && !r.hasta) { alert("Indica al menos la fecha 'desde'."); return; }
      const desde = r.desde || r.hasta;
      const hasta = r.hasta || r.desde;
      if (!Array.isArray(this.version.restriccionesFechas)) this.$set(this.version, "restriccionesFechas", []);
      this.version.restriccionesFechas.push({ desde, hasta, motivo: (r.motivo || "").trim() });
      this.nuevaRestriccion = { desde: "", hasta: "", motivo: "" };
    },
    quitarRestriccion(index) {
      this.version.restriccionesFechas.splice(index, 1);
    },
    async guardar() {
      this.guardando = true;
      try {
        const data = { ...this.version };
        delete data.id;
        data.padreId = this.padreId;
        if (this.padre && this.padre.slug) data.padreSlug = this.padre.slug;
        data.ts = firebase.firestore.FieldValue.serverTimestamp();
        await db.collection("experiencias").doc(this.padreId).collection("versiones").doc(this.vid).set(data, { merge: true });
        this.$router.go(-1);
      } catch (e) {
        alert("No se pudo guardar: " + (e && e.message));
      } finally {
        this.guardando = false;
      }
    },
    async eliminar() {
      if (!confirm("¿Eliminar esta versión?")) return;
      try {
        await db.collection("experiencias").doc(this.padreId).collection("versiones").doc(this.vid).delete();
        this.$router.go(-1);
      } catch (e) {
        alert("No se pudo eliminar: " + (e && e.message));
      }
    },
  },
};
</script>
